import { render, staticRenderFns } from "./DuePortfolioSupplierStats.vue?vue&type=template&id=b4cb2272&"
import script from "./DuePortfolioSupplierStats.vue?vue&type=script&lang=js&"
export * from "./DuePortfolioSupplierStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports